import React, { useState } from "react";
import axios from "axios";
import { API } from "../App";

export default function AffiliateDashboard() {
  const [email, setEmail] = useState("");
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLookup = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    setError("");
    setStats(null);
    try {
      const res = await axios.get(`${API}/api/affiliates/my-stats`, { params: { email: email.trim() } });
      setStats(res.data);
    } catch (err) {
      setError(err.response?.data?.detail || "Could not find your affiliate account. Check your email and try again.");
    } finally {
      setLoading(false);
    }
  };

  const S = {
    page: { minHeight: "100vh", background: "#F9FAFB", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif" },
    card: { background: "#fff", borderRadius: 20, boxShadow: "0 4px 32px rgba(0,0,0,0.08)", padding: "40px 36px", width: "100%", maxWidth: 540 },
    h1: { fontSize: 24, fontWeight: 800, color: "#111827", margin: "0 0 6px" },
    sub: { fontSize: 14, color: "#6B7280", margin: "0 0 24px" },
    input: { width: "100%", boxSizing: "border-box", border: "1px solid #E5E7EB", borderRadius: 10, padding: "12px 14px", fontSize: 14, outline: "none", fontFamily: "inherit", marginBottom: 12 },
    btn: { width: "100%", padding: 13, background: "#1A4D2E", color: "#fff", border: "none", borderRadius: 12, fontSize: 15, fontWeight: 700, cursor: "pointer" },
    err: { background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: 10, padding: "10px 14px", fontSize: 13, color: "#DC2626", marginBottom: 12 },
    statGrid: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 20 },
    stat: { background: "#F9FAFB", border: "1px solid #E5E7EB", borderRadius: 12, padding: "14px 16px", textAlign: "center" },
    statNum: { fontSize: 28, fontWeight: 900, color: "#1A4D2E" },
    statLabel: { fontSize: 11, color: "#6B7280", fontWeight: 600, marginTop: 2 },
    codeBox: { background: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: 12, padding: "16px 20px", marginBottom: 20, display: "flex", alignItems: "center", justifyContent: "space-between" },
    code: { fontFamily: "monospace", fontSize: 22, fontWeight: 900, color: "#1A4D2E", letterSpacing: 2 },
    infoRow: { display: "flex", justifyContent: "space-between", fontSize: 13, color: "#374151", padding: "8px 0", borderBottom: "1px solid #F3F4F6" },
    pending: { textAlign: "center", padding: "24px 0" },
  };

  const copyCode = () => {
    if (stats?.code) navigator.clipboard.writeText(stats.code);
  };

  if (!stats) return (
    <div style={S.page}>
      <div style={S.card}>
        <h1 style={S.h1}>Affiliate Dashboard</h1>
        <p style={S.sub}>Enter your email address to view your referral stats.</p>
        <form onSubmit={handleLookup}>
          <input
            style={S.input} type="email" value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="your@email.com" required
          />
          {error && <div style={S.err}>{error}</div>}
          <button type="submit" style={{ ...S.btn, opacity: loading ? 0.7 : 1 }} disabled={loading}>
            {loading ? "Looking up…" : "View my stats"}
          </button>
        </form>
        <p style={{ fontSize: 12, color: "#9CA3AF", textAlign: "center", marginTop: 16 }}>
          Not a partner yet?{" "}
          <a href="/affiliate" style={{ color: "#1A4D2E", fontWeight: 600, textDecoration: "none" }}>Apply here →</a>
        </p>
      </div>
    </div>
  );

  if (stats.status !== "approved") return (
    <div style={S.page}>
      <div style={S.card}>
        <div style={S.pending}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>⏳</div>
          <h2 style={{ fontSize: 20, fontWeight: 800, color: "#111827", marginBottom: 8 }}>Application under review</h2>
          <p style={{ fontSize: 14, color: "#6B7280" }}>{stats.message}</p>
          <p style={{ fontSize: 13, color: "#9CA3AF", marginTop: 8 }}>
            Status: <strong style={{ textTransform: "capitalize" }}>{stats.status}</strong>
          </p>
        </div>
      </div>
    </div>
  );

  const shareUrl = `${window.location.origin}/register?ref=${stats.code}`;

  return (
    <div style={S.page}>
      <div style={{ ...S.card, maxWidth: 600 }}>
        <div style={{ marginBottom: 24 }}>
          <h1 style={S.h1}>Welcome back, {stats.name}!</h1>
          <p style={S.sub}>{stats.type === "accountant" ? "Accountant" : "Influencer"} partner · {stats.discount_percent}% off for your referrals</p>
        </div>

        {/* Referral code */}
        <div style={S.codeBox}>
          <div>
            <div style={{ fontSize: 11, color: "#6B7280", fontWeight: 600, marginBottom: 4 }}>YOUR REFERRAL CODE</div>
            <div style={S.code}>{stats.code}</div>
          </div>
          <button
            onClick={copyCode}
            style={{ background: "#1A4D2E", color: "#fff", border: "none", borderRadius: 8, padding: "8px 16px", fontSize: 13, fontWeight: 700, cursor: "pointer" }}
          >
            Copy code
          </button>
        </div>

        {/* Share link */}
        <div style={{ background: "#F9FAFB", border: "1px solid #E5E7EB", borderRadius: 10, padding: "12px 14px", marginBottom: 20 }}>
          <div style={{ fontSize: 11, color: "#6B7280", fontWeight: 600, marginBottom: 4 }}>SHARE LINK</div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ flex: 1, fontSize: 12, color: "#374151", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{shareUrl}</span>
            <button
              onClick={() => navigator.clipboard.writeText(shareUrl)}
              style={{ background: "#E5E7EB", color: "#374151", border: "none", borderRadius: 6, padding: "6px 12px", fontSize: 12, fontWeight: 600, cursor: "pointer", flexShrink: 0 }}
            >
              Copy
            </button>
          </div>
        </div>

        {/* Stats */}
        <div style={S.statGrid}>
          <div style={S.stat}>
            <div style={S.statNum}>{stats.total_referrals}</div>
            <div style={S.statLabel}>Total referrals</div>
          </div>
          <div style={S.stat}>
            <div style={S.statNum}>{stats.active_subscribers}</div>
            <div style={S.statLabel}>Active subscribers</div>
          </div>
          <div style={{ ...S.stat, background: "#F0FDF4", border: "1px solid #86EFAC" }}>
            <div style={{ ...S.statNum, color: "#059669" }}>${stats.monthly_earnings_estimate.toFixed(2)}</div>
            <div style={S.statLabel}>This month (est.)</div>
          </div>
        </div>

        {/* Details */}
        <div style={{ background: "#F9FAFB", borderRadius: 12, padding: "16px 20px" }}>
          <div style={S.infoRow}>
            <span style={{ color: "#6B7280" }}>Commission rate</span>
            <span style={{ fontWeight: 600 }}>${stats.commission_rate}/month per active subscriber</span>
          </div>
          <div style={S.infoRow}>
            <span style={{ color: "#6B7280" }}>Referral discount</span>
            <span style={{ fontWeight: 600 }}>{stats.discount_percent}% off for 12 months</span>
          </div>
          <div style={{ ...S.infoRow, borderBottom: "none" }}>
            <span style={{ color: "#6B7280" }}>Payment</span>
            <span style={{ fontWeight: 600 }}>
              {stats.bank_bsb && stats.bank_account
                ? `BSB ${stats.bank_bsb} · Acc ${stats.bank_account}`
                : "Bank details not on file — contact support"}
            </span>
          </div>
        </div>

        <p style={{ fontSize: 12, color: "#9CA3AF", textAlign: "center", marginTop: 16 }}>
          Commissions paid monthly. Questions? <a href="mailto:findjoy143@gmail.com" style={{ color: "#1A4D2E" }}>findjoy143@gmail.com</a>
        </p>
      </div>
    </div>
  );
}
